/* CladOstomy theme runtime — header state, overlays, cart, product pickers, collection filters, size finder */
(function () {
  'use strict';
  var d = document, body = d.body;
  var $ = function (s, r) { return (r || d).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };
  var isIndex = body.classList.contains('tpl-index');
  var FREE = 7500, SHIP = 1000;   /* free shipping from $75 in the US, UK, EU and Australia; below that the flat rate is $10 (the shipping policy) */
  function money(c) { var v = c / 100; return '$' + (Math.abs(Math.round(v * 100) % 100) === 0 ? Math.round(v) : v.toFixed(2)); }
  function escHtml(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function param(n) { try { return new URLSearchParams(location.search).get(n); } catch (e) { return null; } }
  function els(name) { return $$('[data-el="' + name + '"]'); }

  /* ---------- header: transparent over the hero, solid once scrolled / hovered; mega menu on hover */
  var hov = 0;
  function hdr() { body.classList.toggle('hdr-on', !isIndex || !!hov || window.scrollY > 24); }
  addEventListener('scroll', hdr, { passive: true });
  function megaClose() { $$('[data-mega-panel]').forEach(function (p) { p.style.display = 'none'; }); }
  var hoverTargets = $$('[data-hdr-wrap]');
  if (!hoverTargets.length) hoverTargets = $$('.hdr-clear,.hdr-solid,header');
  hoverTargets.forEach(function (e) {
    e.addEventListener('mouseenter', function () { hov = 1; hdr(); });
    e.addEventListener('mouseleave', function () { hov = 0; hdr(); megaClose(); });
  });
  $$('[data-mega]').forEach(function (a) {
    a.addEventListener('mouseenter', function () { megaClose(); var p = $('[data-mega-panel="' + a.getAttribute('data-mega') + '"]'); if (p) p.style.display = ''; });
  });
  hdr();

  /* ---------- accordions, data-go, drag-to-scroll rows (same behaviour as the static export) */
  d.addEventListener('click', function (e) {
    var t = e.target.closest('[data-acc-toggle]');
    if (t) {
      e.preventDefault();
      var b = t.parentElement.querySelector('[data-acc-body]');
      if (b) { var open = b.style.display === 'none'; b.style.display = open ? '' : 'none'; var i = t.querySelector('i'); if (i) i.style.transform = open ? 'rotate(-135deg)' : 'rotate(45deg)'; }
      return;
    }
    var g = e.target.closest('[data-go]');
    if (g && !e.target.closest('a,button')) location.href = g.getAttribute('data-go');
  });
  function dragScroll(el) {
    var cs = getComputedStyle(el); if (cs.overflowX !== 'auto' && cs.overflowX !== 'scroll') return;
    var down = false, sx = 0, sl = 0, moved = false;
    el.addEventListener('mousedown', function (e) { down = true; moved = false; sx = e.pageX; sl = el.scrollLeft; });
    el.addEventListener('mousemove', function (e) { if (!down) return; var dx = e.pageX - sx; if (Math.abs(dx) > 4) moved = true; if (moved) { e.preventDefault(); el.scrollLeft = sl - dx; } });
    ['mouseup', 'mouseleave'].forEach(function (n) { el.addEventListener(n, function () { down = false; }); });
    el.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
  }
  $$('.hs').forEach(dragScroll);

  /* ---------- overlays */
  var LOCKERS = ['bag', 'menu', 'popup', 'filter'];
  function lock() { body.classList.toggle('lock', LOCKERS.some(function (n) { return els(n).some(function (el) { return !el.hidden; }); })); }
  function show(name, on) { els(name).forEach(function (el) { el.hidden = !on; }); lock(); }
  function isOpen(name) { return els(name).some(function (el) { return !el.hidden; }); }
  function closeAll() { ['bag', 'menu', 'popup', 'filter', 'sort', 'contact'].forEach(function (n) { show(n, false); }); }
  /* 2026-09-17 (user): a phone sheet closes by dragging its grip - the little bar at the top - or its header row
     downwards, the way a native sheet does. The sheet follows the finger; past 90 px (or a quick flick) it slides
     off and closes, otherwise it springs back. Pointer events cover touch and mouse; touch-action:none on the grip
     row keeps the browser from turning the gesture into a page scroll. */
  function sheetDrag(grip) {
    var sheet = grip.parentNode, root = grip.closest('[data-el]'), name = root && root.getAttribute('data-el');
    if (!sheet || !name || !window.PointerEvent) return;
    /* 2026-10-20: the phone bag is a panel from the right (data-side="right"); its header row is the grip and a drag
       to the right closes it. Bottom sheets keep the grip + header rows and the downward drag. */
    var side = grip.getAttribute('data-side') === 'right', axis = side ? 'X' : 'Y', pos = function (e) { return side ? e.clientX : e.clientY; };
    var header = side ? null : grip.nextElementSibling, zones = header ? [grip, header] : [grip];
    var y0 = 0, t0 = 0, dy = 0, id = null, anim = sheet.style.animation;   /* the sheetUp / panelIn entrance, put back after a drag */
    zones.forEach(function (z) { z.style.touchAction = 'none'; z.style.cursor = 'grab'; });
    function move(e) {
      if (e.pointerId !== id) return;
      dy = Math.max(0, pos(e) - y0);
      sheet.style.transform = 'translate' + axis + '(' + dy + 'px)';
    }
    function end(e) {
      if (e.pointerId !== id) return;
      id = null;
      d.removeEventListener('pointermove', move); d.removeEventListener('pointerup', end); d.removeEventListener('pointercancel', end);
      var quick = dy > 24 && (Date.now() - t0) < 260;
      if (dy > 90 || quick) {
        sheet.style.transition = 'transform 200ms ease-in';
        sheet.style.transform = 'translate' + axis + '(110%)';
        setTimeout(function () { show(name, false); sheet.style.transition = ''; sheet.style.transform = ''; sheet.style.animation = anim; }, 200);
      } else {
        sheet.style.transition = 'transform 220ms cubic-bezier(.2,.7,.3,1)';
        sheet.style.transform = '';
        setTimeout(function () { sheet.style.transition = ''; sheet.style.animation = anim; }, 240);
      }
    }
    zones.forEach(function (z) {
      z.addEventListener('pointerdown', function (e) {
        if (e.target.closest('a,button,input,select') || e.button) return;
        id = e.pointerId; y0 = pos(e); t0 = Date.now(); dy = 0;
        sheet.style.animation = 'none'; sheet.style.transition = 'none';
        d.addEventListener('pointermove', move); d.addEventListener('pointerup', end); d.addEventListener('pointercancel', end);
      });
    });
  }
  $$('[data-sheet-grip]').forEach(sheetDrag);
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  d.addEventListener('click', function (e) {
    if (e.target.closest('[data-el="sort"],[data-act="toggle-sort"],[data-act="open-sort"]')) return;
    els('sort').forEach(function (el) { if (el.closest('.dsk')) el.hidden = true; });
  });
  var seen = false; try { seen = !!localStorage.getItem('clad_popup_seen'); } catch (e) {}
  function popupSeen() { try { localStorage.setItem('clad_popup_seen', '1'); } catch (e) {} }
  /* the welcome popup waits for Shopify's cookie banner: that banner sits at z-index 2000000 and would bury the
     offer (and its email field) on a phone, so the popup only arms once consent has been answered */
  function consentBannerUp() {
    var b = d.querySelector('.shopify-pc__banner');
    if (!b) return false;
    var st = getComputedStyle(b);
    /* offsetParent is null for any position:fixed element, so measure the box instead */
    return st.display !== 'none' && st.visibility !== 'hidden' && b.getBoundingClientRect().height > 0;
  }
  /* when it opens. 2026-09-14 (user): 8 s after the first scroll or click, 12 s without one. 2026-09-19 (conversion
     audit, owner's decision) replaces that: the popup never opens by itself on a product page or on the cart - a
     shopper reading the product is not interrupted, and the offer has its own line under the buy button there
     (data-act="open-popup"). Everywhere else it opens once, 45 s after it is armed (page load, or the cookie banner
     being answered), unless the visitor has seen it meanwhile or has the bag, menu or filter open at that moment. */
  var POPUP_OFF = true, POPUP_MS = 45000;
  function armPopup() {
    if (POPUP_OFF) return;
    function seenQuiet() { try { return !!localStorage.getItem('clad_popup_seen'); } catch (e) { return false; } }
    setTimeout(function () {
      if (seenQuiet()) return;
      els('popup').forEach(function (el) {
        var half = el.closest('.dsk,.mob');
        if (!half || getComputedStyle(half).display !== 'none') $$('img[loading="lazy"]', el).forEach(function (im) { im.loading = 'eager'; });
      });
    }, POPUP_MS - 4000);                     /* the offer photo, fetched a little ahead */
    setTimeout(function () {
      if (!seenQuiet() && !isOpen('popup') && !['bag', 'menu', 'filter'].some(isOpen) && !consentBannerUp()) show('popup', true);
    }, POPUP_MS);
  }
  if (!seen && els('popup').length) {
    if (!consentBannerUp()) armPopup();
    else {
      var armed = false, arm = function () { if (armed) return; armed = true; armPopup(); };
      d.addEventListener('visitorConsentCollected', arm);
      var poll = setInterval(function () { if (!consentBannerUp()) { clearInterval(poll); arm(); } }, 700);
      setTimeout(function () { clearInterval(poll); }, 180000);
    }
  }

  var toastT;
  function toast(msg) {
    $$('[data-toast-text]').forEach(function (el) { el.textContent = msg; });
    els('toast').forEach(function (el) { el.hidden = false; });
    clearTimeout(toastT); toastT = setTimeout(function () { els('toast').forEach(function (el) { el.hidden = true; }); }, 2600);
  }

  /* ---------- cart (Ajax API) */
  var cart = null;
  function fetchJson(url, opts) {
    opts = opts || {}; opts.credentials = 'same-origin';
    opts.headers = Object.assign({ 'Accept': 'application/json' }, opts.headers || {});
    return fetch(url, opts).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Request failed'); return j; }); });
  }
  function loadCart() { return fetchJson('/cart.js').then(function (c) { cart = c; renderBag(); return c; }); }
  /* the names the bag's discount line shows (2026-10-20), the same as snippets/discount-name.liquid on the cart page:
     the Ostomy Awareness Month code gets its campaign name, another code says it is a code, an automatic discount
     keeps its admin name less a tier mark like " (2+)" (2026-10-24: the pack-price tiers "Everyday Wrap pack price
     (2+)" and "(3+)" are two admin discounts that show as one line) */
  function discountName(a) { var t = a.title || ''; return t === 'OSTODAY15' ? 'Ostomy Awareness Month · 15% off' : (a.type === 'discount_code' ? 'Code ' + t : t.replace(/\s*\(\d+\+\)$/, '')); }
  /* every discount on the cart with what it takes off, in the order they first appear (cart-level ones, then the
     ones allocated to lines) - one small line each in the bag, above the total (Chris, 2026-10-20); discounts that
     show under the same name share a line */
  function discountLines(c) {
    var sum = {}, order = [];
    function add(a, amt) { if (!(a && a.title)) return; var t = discountName(a); if (!(t in sum)) { sum[t] = 0; order.push({ title: t, name: t }); } sum[t] += amt || 0; }
    (c.cart_level_discount_applications || []).forEach(function (a) { add(a, a.total_allocated_amount); });
    (c.items || []).forEach(function (it) { (it.line_level_discount_allocations || []).forEach(function (al) { add(al.discount_application, al.amount); }); });
    return order.map(function (o) { return { name: o.name, amount: sum[o.title] }; });
  }
  function renderBag() {
    if (!cart) return;
    var n = cart.item_count, total = cart.total_price, toFree = FREE - total;
    /* the amount is bold everywhere; colours only inside the bag drawer - the header's black bar keeps its own light text
       (user, 2026-09-16: the amount had gone black on black up there) */
    var plain = total === 0 ? 'Free shipping on orders of $75 and over' : toFree > 0 ? 'Just <b>' + money(toFree) + '</b> away from free shipping' : '✓ Free shipping unlocked';
    var txt = total === 0 ? plain : toFree > 0 ? 'Just <b style="color:#1A1714">' + money(toFree) + '</b> away from free shipping' : '<b style="color:#2A7A64">✓ Free shipping unlocked</b>';
    $$('[data-bag-count]').forEach(function (el) { el.textContent = n; });
    $$('[data-bag-subtotal]').forEach(function (el) { el.textContent = money(total); });
    var disc = cart.total_discount || 0;
    var lines = discountLines(cart);
    $$('[data-bag-discount]').forEach(function (el) {
      el.hidden = disc <= 0;
      var box = el.querySelector('[data-bag-discount-lines]');
      if (box) box.innerHTML = lines.map(function (l) { return '<div style="display:flex;justify-content:space-between;gap:12px"><span style="min-width:0">' + escHtml(l.name) + '</span><span style="font-variant-numeric:tabular-nums;white-space:nowrap">\u2212' + money(l.amount) + '</span></div>'; }).join('');
    });
    $$('[data-bag-discount-amt]').forEach(function (el) { el.textContent = '\u2212' + money(disc); });
    $$('[data-ship-text]').forEach(function (el) { el.innerHTML = el.closest('[data-el="bag"]') ? txt : plain; });
    $$('[data-bag-count-word]').forEach(function (el) { el.textContent = n === 1 ? 'item' : 'items'; });
    $$('[data-ship-bar]').forEach(function (el) { el.style.width = Math.min(100, Math.round(total * 100 / FREE)) + '%'; });
    $$('[data-bag-items]').forEach(function (box) {
      var tpl = box.querySelector('template[data-tpl="bag-item"]'), empty = box.querySelector('[data-el="bag-empty"]');
      if (!tpl || !empty) return;
      $$('[data-bag-row]', box).forEach(function (r) { r.remove(); });
      var html = cart.items.map(function (it) {
        var img = it.image ? it.image + (it.image.indexOf('?') >= 0 ? '&' : '?') + 'width=200' : '';
        return tpl.innerHTML.replace(/#bag-item-img|\{img\}/g, img).replace(/\{name\}/g, escHtml(it.product_title)).replace(/\{variant\}/g, it.variant_title ? escHtml(it.variant_title.replace(/ \/ /g, ' · ').replace(/ · 1-pack$/, '')) : '')
          .replace(/\{sku\}/g, escHtml(it.sku || '')).replace(/\{qty\}/g, it.quantity).replace(/\{line\}/g, money(it.final_line_price)).replace(/\{key\}/g, it.key);
      }).join('');
      empty.insertAdjacentHTML('beforebegin', html);
      empty.hidden = n > 0;
    });
    renderUpsell();
  }
  /* ---------- bag drawer: one offer at a time (2026-09-16), the first product of the chain that is not in the bag */
  var UPSELL_CFG = (function () { var e = $('script[data-upsell]'); try { return e ? JSON.parse(e.textContent) : null; } catch (err) { return null; } })();
  var UPSELL = (UPSELL_CFG && UPSELL_CFG.items) || [];
  var UPS = {};   /* per product: the colour, size and quantity picked in the offer card */
  function upsOpt(p, kind) {
    var idx = -1, vals = [];
    /* the pill row is the Size option, or the Pack option on products that only come in packs (scissors) */
    (p.opts || []).forEach(function (name, j) {
      if (kind === 'colour') { if (/^colou?r$/i.test(name)) idx = j; }
      else if (/^size$/i.test(name) || (idx < 0 && /^pack$/i.test(name))) idx = j;
    });
    if (idx >= 0) p.vs.forEach(function (v) { if (vals.indexOf(v.o[idx]) < 0) vals.push(v.o[idx]); });
    /* only what the product page sells, in its order (the Shopify product may carry extra variants, e.g. the
       XS / XXL wrap ones): `cols` and `sizes` come from the design data; a size-less product keeps its Pack values */
    var want = kind === 'colour' ? p.cols : p.sizes;
    if (want && want.length) {
      var keep = want.filter(function (n) { return vals.indexOf(n) >= 0; });
      if (keep.length) vals = keep;
    }
    return { i: idx, vals: vals };
  }
  function upsVariant(p, ci, si) {
    var c = upsOpt(p, 'colour'), z = upsOpt(p, 'size');
    return p.vs.filter(function (v) { return (c.i < 0 || v.o[c.i] === c.vals[ci]) && (z.i < 0 || v.o[z.i] === z.vals[si]); })[0] || null;
  }
  function upsMissing() {
    if (!cart || !cart.item_count) return [];
    var have = {};
    cart.items.forEach(function (i) { have[i.handle] = 1; });
    return UPSELL.filter(function (p) { return p && p.t && p.vs && p.vs.length && !have[p.h]; });
  }
  function upsById(h) { return UPSELL.filter(function (p) { return p.h === h; })[0] || null; }
  /* a card opens on a combination that is actually in stock */
  function upsFirstFree(p) {
    var c = upsOpt(p, 'colour'), z = upsOpt(p, 'size');
    for (var i = 0; i < Math.max(1, c.vals.length); i++) {
      for (var j = 0; j < Math.max(1, z.vals.length); j++) {
        var v = upsVariant(p, i, j);
        if (v && v.a) return { ci: i, si: j };
      }
    }
    return { ci: 0, si: 0 };
  }
  /* 2026-09-19: a product with a real Size option opens with no size chosen, like its product page - the shopper picks
     one before it goes in the bag (a wrong size costs a free replacement). Pack-only products keep their default. */
  function upsSized(p) { return (p.opts || []).some(function (n) { return /^size$/i.test(n); }); }
  function upsState(p) {
    if (!UPS[p.h]) { var f = upsFirstFree(p); UPS[p.h] = { ci: f.ci, si: upsSized(p) ? null : f.si, q: 1 }; }
    return UPS[p.h];
  }
  function upsPrice(p) { var s = upsState(p), v = upsVariant(p, s.ci, s.si); return v ? v.p : p.price; }
  function upsImg(p) {
    var c = upsOpt(p, 'colour'), s = upsState(p);
    var u = (c.i >= 0 && p.cimg && p.cimg[c.vals[s.ci]]) || '';
    return u ? u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=200' : (p.img || '');
  }
  /* what the order looks like once `add` cents go in: whether this is what unlocks free shipping (the spend
     discounts the card used to announce ended on 2026-10-24, so `pct` stays 0) */
  function upsDeal(add) {
    var gross = cart ? cart.items_subtotal_price : 0, after = gross + add;
    return { pct: 0, unlocks: after >= FREE && gross < FREE };
  }
  function upsBadges(deal) {
    return {
      off: deal.pct ? '<span style="position:absolute;left:-4px;bottom:-4px;font-size:9px;font-weight:600;padding:1px 5px;border-radius:999px;background:#1A1714;color:#FBF8F4;line-height:1.3">−' + deal.pct + '%</span>' : '',
      badge: deal.pct ? '<span style="align-self:flex-start;font-size:9px;font-weight:600;letter-spacing:.04em;text-transform:uppercase;padding:1px 6px;border-radius:999px;background:#1A1714;color:#FBF8F4;line-height:1.4">' + deal.pct + '% off this order</span>' : '',
      effect: deal.unlocks ? '<b style="color:#2A7A64;font-weight:600">✓ Free shipping</b>' : ''
    };
  }
  /* the pack tag the collection card carries ("2-pack", "20-pack"), on the picture's top-left corner */
  function upsTag(p) {
    return p.tag ? '<span style="position:absolute;left:-4px;top:-4px;font-size:9px;font-weight:600;padding:1px 5px;border-radius:999px;background:#FBF8F4;border:1px solid #E6DDD2;color:#1A1714;line-height:1.3;white-space:nowrap">' + escHtml(p.tag) + '</span>' : '';
  }
  function upsMoney(total, pct) {
    return pct ? '<s style="color:#8A8178;font-weight:500;font-size:11.5px">' + money(total) + '</s> ' + money(Math.round(total * (100 - pct) / 100)) : money(total);
  }
  function upsPill(kind, p, i, on, label, extra) {
    return '<button type="button" data-ups-pick="' + kind + '" data-h="' + p.h + '" data-i="' + i + '" style="font-family:inherit;font-size:10.5px;line-height:1.25;padding:2px 6px;border-radius:999px;cursor:pointer;border:1px solid '
      + (on ? '#1A1714' : '#D2C5B5') + ';background:' + (on ? '#1A1714' : 'transparent') + ';color:' + (on ? '#FBF8F4' : '#1A1714') + (extra || '') + '">' + label + '</button>';
  }
  /* the picks like siilostomy's card: colour dots, then size pills, then the price (struck when the order earns a
     discount) with the 1x / 2x choice at its right, and the free-shipping line under it - no labels */
  function upsRows(dots, sizes) {
    /* 2026-09-17 (user): the colour dots and the size pills share one line - the dots as a group, a wider gap, then
       the pills; the line only wraps if a product ever has more options than the column can hold */
    if (!dots && !sizes) return '';
    return '<div style="display:flex;gap:4px;align-items:center;flex-wrap:wrap">'
      + (dots ? '<span style="display:inline-flex;gap:5px;align-items:center;margin-right:' + (sizes ? '5px' : '0') + ';padding:2px 0 2px 2px">' + dots + '</span>' : '')
      + sizes + '</div>';
  }
  /* price and the free-shipping note share a line (user, 2026-09-16) */
  function upsPriceLine(price, effect) {
    return '<div style="display:flex;align-items:baseline;gap:6px;white-space:nowrap"><span style="font-size:13px;font-weight:600;font-variant-numeric:tabular-nums">' + price + '</span>'
      + (effect ? '<span data-ups-effect style="font-size:10.5px;line-height:1.3">' + effect + '</span>' : '') + '</div>';
  }
  function upsSingle(p, tpl) {
    var s = upsState(p), c = upsOpt(p, 'colour'), z = upsOpt(p, 'size'), v = upsVariant(p, s.ci, s.si), unit = upsPrice(p);
    var dots = c.vals.map(function (name, i) {
      var on = i === s.ci, any = p.vs.some(function (x) { return x.a && x.o[c.i] === name; });
      return '<button type="button" data-ups-pick="colour" data-h="' + p.h + '" data-i="' + i + '" title="' + escHtml(name) + '" aria-label="' + escHtml(name) + '" style="width:14px;height:14px;border-radius:50%;flex:none;'
        + 'border:1px solid #D2C5B5;box-sizing:border-box;cursor:pointer;background:' + (p.sw[name] || '#F4EEE6') + ';background-size:cover;padding:0;opacity:' + (any ? '1' : '.4')
        + ';box-shadow:' + (on ? '0 0 0 1.5px #FFFFFF,0 0 0 2.5px #1A1714' : 'none') + '"></button>';
    }).join('');
    var sizes = z.vals.map(function (name, j) {
      var vv = upsVariant(p, s.ci, j), free = !!(vv && vv.a);
      return upsPill('size', p, j, j === s.si, escHtml(name), ';opacity:' + (free ? '1' : '.45') + ';text-decoration:' + (free ? 'none' : 'line-through'));
    }).join('');
    /* one unit per add (user, 2026-09-16: the 1x/2x choice and the pair total made the card look bloated) */
    var deal = upsDeal(unit), b = upsBadges(deal);
    /* the template keeps its link and picture as data-u / data-i (no href / src with a placeholder in the page source
       for a link checker to follow); they become href / src here, once the real values are in */
    var html = tpl.innerHTML.replace(/\{h\}/g, p.h).replace(/\{url\}/g, p.u || '#').replace(/\{img\}/g, upsImg(p)).replace(/\{name\}/g, escHtml(p.t))
      .replace(/<a data-u="/g, '<a href="').replace(/<img data-i="/g, '<img src="')
      .replace(/\{offbadge\}/g, b.off + upsTag(p)).replace(/\{badge\}/g, b.badge)
      .replace(/\{rows\}/g, upsRows(c.vals.length > 1 ? dots : '', sizes)).replace(/\{price\}/g, upsPriceLine(upsMoney(unit, deal.pct), b.effect));
    return { html: html, ok: (upsSized(p) && s.si == null) || !!(v && v.a) };   /* no size yet: the button stays live and asks for one */
  }
  /* 2026-09-18 (user): the offers can be dismissed - the small x beside "Goes well with" hides them for the rest of
     the visit (sessionStorage; a new visit shows them again) */
  /* 2026-10-20 (Chris): the "Goes well with" offers are switched off for everyone; set UPS_OFF back to the
     sessionStorage reading below to bring them back */
  var UPS_OFF = true; try { if (!UPS_OFF) UPS_OFF = sessionStorage.getItem('clad_ups_off') === '1'; } catch (e) {}
  function upsellHide() {
    UPS_OFF = true; try { sessionStorage.setItem('clad_ups_off', '1'); } catch (e) {}
    renderUpsell();
  }
  function renderUpsell() {
    var list = UPS_OFF ? [] : upsMissing();
    $$('[data-upsell-box]').forEach(function (box) {
      var par = box.parentElement || d;
      var tplS = par.querySelector('[data-tpl="upsell"]');   /* a text/x-template script since 2026-09-18 (link checkers followed the placeholders inside a <template>) */
      if (!list.length || !tplS) { box.hidden = true; box.innerHTML = ''; box._sig = ''; return; }
      /* a pick on a card re-renders the row; that must not throw the row back to the first card (bug, 2026-09-16), so
         the scroll position is kept while the same products are on offer and reset when the line-up changes */
      var shown = list.slice(0, 4), sig = shown.map(function (p) { return p.h; }).join(','), old = box.querySelector('.hs'), keep = (old && box._sig === sig) ? old.scrollLeft : 0;
      box._sig = sig;
      var cards = shown.map(function (p) { return upsSingle(p, tplS); });
      /* each card floats on its own (white, a soft shadow); the row scrolls sideways when there is more than one */
      box.innerHTML = '<div style="display:flex;align-items:center;justify-content:space-between;gap:8px;margin:0 0 6px">'
        + '<span style="font-size:10px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;color:#8A8178">Goes well with</span>'
        + '<button type="button" data-act="upsell-hide" aria-label="Hide these suggestions" title="Hide these suggestions" style="flex:none;width:22px;height:22px;border-radius:50%;border:0;background:#F4EEE6;'
        + 'color:#4A443E;font-size:15px;line-height:1;display:grid;place-items:center;cursor:pointer;font-family:inherit;padding:0">×</button></div>'
        + '<div class="hs" style="display:flex;gap:8px;overflow-x:auto;scroll-snap-type:x proximity;scrollbar-width:none;padding:2px 2px 8px;margin:0 -2px">'
        + cards.map(function (c) { return c.html; }).join('') + '</div>';
      $$('[data-act="upsell-add"]', box).forEach(function (btn, i) {
        if (cards[i] && cards[i].ok) return;
        btn.style.background = '#F4EEE6'; btn.style.color = '#8A8178'; btn.style.borderColor = '#E6DDD2'; btn.disabled = true;
      });
      box.hidden = false;
      var hs = box.querySelector('.hs');
      if (hs) { hs.scrollLeft = keep; dragScroll(hs); }   /* visible first: scrollLeft on a hidden box is ignored */
    });
  }
  d.addEventListener('click', function (e) {
    var t = e.target.closest('[data-ups-pick]'); if (!t) return;
    e.preventDefault();
    var p = upsById(t.getAttribute('data-h')); if (!p) return;
    var s = upsState(p), kind = t.getAttribute('data-ups-pick'), i = +t.getAttribute('data-i');
    if (kind === 'colour') { s.ci = i; if (s.si != null && !upsVariant(p, s.ci, s.si)) s.si = null; }   /* the size may not be made in that color */
    else {
      if (!upsVariant(p, s.ci, i)) { toast(upsOpt(p, 'size').vals[i] + ' is not made in ' + upsOpt(p, 'colour').vals[s.ci]); return; }
      s.si = i;
    }
    renderUpsell();
  });
  function upsellAdd(btn) {
    var p = upsById(btn.getAttribute('data-h')); if (!p) return;
    var s = upsState(p), v = upsVariant(p, s.ci, s.si);
    if (upsSized(p) && s.si == null) {
      toast('Select a size first');
      var card = btn.closest('[data-upsell-box] .hs > div'), row = card && card.querySelector('[data-ups-pick="size"]');
      if (row && row.parentElement) { var pr = row.parentElement; pr.style.transition = 'box-shadow 200ms'; pr.style.borderRadius = '10px'; pr.style.boxShadow = '0 0 0 3px #FFFFFF, 0 0 0 5px #F2583B'; setTimeout(function () { pr.style.boxShadow = ''; }, 1800); }
      return;
    }
    if (!v || !v.a) { toast('Sold out in this option'); return; }
    var items = [{ id: v.id, quantity: 1 }], list = [p];
    btn.style.opacity = '.6';
    addItems(items).then(function () { list.forEach(function (p) { delete UPS[p.h]; }); })
      .catch(function (err) { toast(err.message || 'Could not add to bag'); })
      .then(function () { btn.style.opacity = ''; });
  }
  function changeQty(key, delta) {
    if (!cart) return loadCart().then(function () { return changeQty(key, delta); });
    var it = cart.items.filter(function (i) { return i.key === key; })[0]; if (!it) return;
    var q = Math.max(0, it.quantity + delta);
    return fetchJson('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: q }) })
      .then(function (c) { cart = c; renderBag(); if (body.classList.contains('tpl-cart')) location.reload(); })
      .catch(function (err) { toast(err.message || 'Could not update the bag'); });
  }
  function addItems(items) {
    return fetchJson('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) }).then(loadCart);
  }
  function addToCart(id, qty) { return addItems([{ id: id, quantity: qty }]); }

  /* ---------- newsletter forms (footer + welcome popup)
     Klaviyo client-side subscription (public key): the profile joins the list and that starts the welcome flow; Klaviyo's
     Shopify integration then writes the customer to Shopify. (Posting Shopify's own /contact customer form by fetch fails
     with "Missing CAPTCHA token", so it is not used.) */
  var KL = window.CLAD_KLAVIYO || {};
  function klaviyoSubscribe(email, source) {
    if (!KL.company || !KL.list) return Promise.reject(new Error('no klaviyo config'));
    var payload = { data: { type: 'subscription', attributes: { custom_source: source, profile: { data: { type: 'profile', attributes: { email: email, properties: { signup_source: source, welcome_code: KL.code || '' }, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } }, relationships: { list: { data: { type: 'list', id: KL.list } } } } };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KL.company), { method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2026-07-15' }, body: JSON.stringify(payload) })
      .then(function (r) { if (!r.ok) throw new Error('klaviyo ' + r.status); return true; });
  }
  function nlDone(f, email) {
    var pop = f.closest('[data-el="popup"]'), btn = f.querySelector('button[type="submit"]'), inp = f.querySelector('input[type="email"]');
    try { if (window.klaviyo && email) window.klaviyo.push(['identify', { email: email }]); } catch (err) {}
    if (pop) {
      $$('[data-nl-email]', pop).forEach(function (x) { x.textContent = email || 'you'; });
      $$('[data-el="popup-form"],[data-el="popup-intro"]', pop).forEach(function (x) { x.hidden = true; });
      $$('[data-el="popup-done"]', pop).forEach(function (x) { x.hidden = false; });
      popupSeen();
    } else { if (inp) { inp.value = ''; inp.placeholder = 'You’re in. Check your inbox.'; } if (btn) btn.textContent = 'Signed up'; }
  }
  $$('form[data-nl]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var inp = f.querySelector('input[type="email"]'), email = inp ? inp.value.trim() : '';
      if (!email) return;
      var btn = f.querySelector('button[type="submit"]'); if (btn) btn.disabled = true;
      var pop = f.closest('[data-el="popup"]');
      klaviyoSubscribe(email, pop ? 'Website welcome popup (10% off)' : 'Website footer signup')
        .then(function () { if (btn) btn.disabled = false; nlDone(f, email); })
        .catch(function () { if (btn) btn.disabled = false; toast('We couldn’t sign you up just now. Please try again.'); });
    });
  });

  /* ---------- restock requests: Klaviyo back-in-stock subscription. The Klaviyo flow "补货到货提醒" e-mails the store at once
     (internal alert = the request record) and the customer when the variant is back. Shopify's /contact form cannot be posted
     by fetch (reCAPTCHA token), so it is not used; the mailto link in the panel is the manual fallback.
     Note: this client endpoint URL must have NO trailing slash (with one the browser gets a CORS failure). */
  $$('form[data-oos]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = f.querySelector('button[type="submit"]'), email = ((f.querySelector('input[type="email"]') || {}).value || '').trim(), vid = (f.querySelector('[data-oos-vid]') || {}).value;
      if (!email || !vid || !KL.company) { toast('Please choose an option and enter your email.'); return; }
      if (btn) btn.disabled = true;
      fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=' + encodeURIComponent(KL.company), {
        method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2026-07-15' },
        body: JSON.stringify({ data: { type: 'back-in-stock-subscription', attributes: { channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email: email } } } }, relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + vid } } } } })
      }).then(function (r) { if (!r.ok) throw new Error('klaviyo ' + r.status); })
        .then(function () {
          try { if (window.klaviyo) window.klaviyo.push(['identify', { email: email }]); } catch (err) {}
          var row = f.querySelector('div'); if (row) row.hidden = true;
          $$('[data-oos-done]', f).forEach(function (x) { x.hidden = false; });
        })
        .catch(function () { if (btn) btn.disabled = false; toast('We couldn’t save that just now. Please try again or email support@cladostomy.com.'); });
    });
  });

  /* ---------- size finder (home + size guide) */
  var SZ = (function () { var s = $('script[data-clad-sizes]'); try { return s ? JSON.parse(s.textContent).sized : []; } catch (e) { return []; } })();
  var MEAS = { waist: 'Waist at stoma height', hip: 'Hip · widest point of the lower abdomen', neck: 'Neck circumference' };
  $$('[data-sz="prod"]').forEach(function (sel) {
    var scope = sel.parentElement;
    var waist = $('[data-sz="waist"]', scope), unit = $('[data-sz="unit"]', scope), meas = $('[data-sz-measure]', scope), how = $('[data-sz-how]', scope);
    var fit = $('[data-el="fit"]', scope), res = $('[data-fit-result]', scope), note = $('[data-fit-note]', scope);
    function prod() { return SZ.filter(function (p) { return p.style === sel.value; })[0] || SZ[0]; }
    function calc() {
      var p = prod(); if (!p) return;
      if (meas) meas.textContent = MEAS[p.measure] || meas.textContent;
      if (how && p.how) how.textContent = p.how;
      var u = unit ? unit.value : 'in', w = parseFloat(waist ? waist.value : ''), r = '', n = '';
      if (!isNaN(w)) {
        var vin = u === 'cm' ? w / 2.54 : w, ranged = p.sizes.filter(function (s) { return s.in; });
        /* 2026-09-17: a cm reading is matched against the cm ranges (they are the exact ones; the inch ranges are
           rounded from them), an inch reading against the inch ranges */
        var band = function (s) { return u === 'cm' && s.cm ? s.cm : s.in; }, x = u === 'cm' ? w : vin;
        var hits = ranged.filter(function (s) { var r = band(s); return x >= r[0] && x <= r[1]; }), uStr = u === 'cm' ? ' cm' : '″';
        var fmtR = function (s) { return u === 'cm' ? s.cm[0] + '–' + s.cm[1] + ' cm' : s.in[0] + '–' + s.in[1] + '″'; };
        if (hits.length === 1) { r = 'Your size is ' + hits[0].size; n = p.site_name + ' · ' + fmtR(hits[0]) + ' · ' + (MEAS[p.measure] || '').toLowerCase() + '.'; }
        else if (hits.length > 1) {
          var a = hits[0], b = hits[hits.length - 1];
          if (p.style === '1084') { r = 'Your size is ' + b.size; n = w + uStr + ' is a boundary number. The Angled Cover has its own rule: between two sizes, take the larger.'; }
          /* the wrap's XS and S share 28 in / 72 cm (the factory's ranges, 2026-09-19): its chart says to size down */
          else if (p.style === '0292') { r = 'Your size is ' + a.size; n = w + uStr + ' is in both ' + a.size + ' and ' + b.size + '. Customers tell us the wrap runs large, so take ' + a.size + '.'; }
          else { r = a.size + ' or ' + b.size; n = a.size + ' for a firmer hold, ' + b.size + ' for a soft belly or for sleeping.'; }
        } else {
          var below = ranged.filter(function (s) { return band(s)[1] < x; }).pop(), above = ranged.filter(function (s) { return band(s)[0] > x; })[0];
          if (below && above) {
            if (p.style === '1084') { r = 'Your size is ' + above.size; n = 'Between two sizes on the Angled Cover, take the larger.'; }
            else { r = 'Your size is ' + below.size; n = w + uStr + ' falls in the gap between ' + below.size + ' and ' + above.size + '. Customers tell us the wrap runs large, so take ' + below.size + '.'; }
          } else {
            /* off the chart. The wrap's XS and XXL have no published range (2026-09-19: now sold): the finder names
               them and keeps the "send us your number" safety net */
            var endSize = !below ? p.sizes[0] : p.sizes[p.sizes.length - 1], named = endSize && !endSize.in ? endSize.size : '';
            var edge = !below ? band(ranged[0])[0] : band(ranged[ranged.length - 1])[1], ask = 'Send us your number and we will confirm the fit before you order.';
            if (!below) { r = named ? 'Likely ' + named : 'Under the chart'; n = (named ? 'Under ' + edge + uStr + ' is ' + named + '. ' : 'Below the smallest size on this chart. ') + ask; }
            else { r = named ? 'Likely ' + named : 'Over the chart'; n = (named ? 'Over ' + edge + uStr + ' is ' + named + '. ' : 'Above the largest size on this chart. ') + ask; }
          }
        }
      }
      if (fit) fit.hidden = !r; if (res) res.textContent = r; if (note) note.textContent = n;
    }
    sel.addEventListener('change', calc);
    if (waist) waist.addEventListener('input', calc);
    if (unit) unit.addEventListener('change', calc);
  });

  /* ---------- collection: sub chips, filters, sort, load more (client side, same rules as the design) */
  var col = null;
  (function () {
    var grids = $$('[data-grid]'); if (!grids.length) return;
    var tools = grids[0].getAttribute('data-collection') === 'care-tools';
    var COLOUR_F = { Black: ['#1A1A1A', '#2E2A28', '#3A3A3A'], Pink: ['#E8A0B4', '#E4B7C8', '#C9A9B8', '#C2386B'], Sand: ['#D9C4A8'], White: ['#F2EEE8'], Gray: ['#8E8E8E', '#9A9A9A', '#C0C0C0'], Blue: ['#2B3A5C', '#2F5C9E', '#B7C9E2', '#8FC4E8'], Prints: [] };
    var ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL'];
    var SORT_N = { best: 'Best selling', low: 'Price: low to high', high: 'Price: high to low', 'new': 'Newest', az: 'A–Z' };
    function nz(s) { return String(s == null ? '' : s).replace(/ /g, ' ').replace(/\s+/g, ' ').trim(); }
    /* 2026-09-12: phones list every product at once (no Load more); desktop keeps pages of 9 */
    var PAGE = 10000;   /* every product at once, desktop too (user, 2026-09-16: no Load more); the pictures lazy-load */
    var S = { sub: nz(param('sub') || 'All'), colour: null, size: null, pack: null, sort: 'best', shown: PAGE };
    function fitsSize(fit, s) {
      if (/one size|pack/i.test(fit)) return true;
      var m = fit.match(/^([A-Z]+)–([A-Z]+)$/); if (m) { var i = ORDER.indexOf(s); return i >= ORDER.indexOf(m[1]) && i <= ORDER.indexOf(m[2]); }
      return fit.split(/[·\/]/).some(function (t) { t = t.trim(); return t === s || t.split('-').indexOf(s) >= 0; });
    }
    function isMulti(c) { return /pack/i.test(c.tag) || /pack/i.test(c.fit); }
    function data(el) { var ds = el.dataset; return { el: el, i: +ds.i, name: ds.name, price: +ds.price, dots: (ds.dots || '').split(','), sw: ds.sw === '1', fit: ds.fit || '', tag: ds.tag || '', group: ds.group, tgroup: ds.tgroup }; }
    function onOff(b, on) { b.style.background = on ? '#1A1714' : 'transparent'; b.style.color = on ? '#FBF8F4' : '#1A1714'; b.style.borderColor = on ? '#1A1714' : '#D2C5B5'; }
    function apply() {
      grids.forEach(function (grid) {
        var scope = grid.closest('.dsk,.mob') || d;
        var all = $$('[data-card]', grid).map(data);
        var pool = all.filter(function (c) { return S.sub === 'All' || (tools ? c.tgroup : c.group) === S.sub; });
        if (S.colour) pool = pool.filter(function (c) { return S.colour === 'Prints' ? c.sw : c.dots.some(function (h) { return COLOUR_F[S.colour].indexOf(h) >= 0; }); });
        if (S.size) pool = pool.filter(function (c) { return fitsSize(c.fit, S.size); });
        if (S.pack) pool = pool.filter(function (c) { return S.pack === 'multi' ? isMulti(c) : !isMulti(c); });
        pool.sort(function (a, b) {
          return S.sort === 'low' ? a.price - b.price : S.sort === 'high' ? b.price - a.price : S.sort === 'az' ? a.name.localeCompare(b.name)
            : S.sort === 'new' ? (((b.tag === 'New') - (a.tag === 'New')) || a.i - b.i) : a.i - b.i;
        });
        var vis = pool.slice(0, S.shown), n = pool.length;
        all.forEach(function (c) { c.el.hidden = vis.indexOf(c) < 0; });
        vis.forEach(function (c) { grid.appendChild(c.el); });
        $$('[data-count]', scope).forEach(function (el) { el.textContent = n + (n === 1 ? ' product' : ' products'); });
        $$('[data-showing]', scope).forEach(function (el) { el.textContent = 'Showing ' + vis.length + ' of ' + n; });
        $$('[data-el="more"]', scope).forEach(function (el) { el.hidden = !(vis.length < n); });
        var prices = pool.map(function (c) { return c.price; });
        $$('[data-pmin]', scope).forEach(function (el) { el.textContent = prices.length ? '$' + Math.min.apply(null, prices) : '—'; });
        $$('[data-pmax]', scope).forEach(function (el) { el.textContent = prices.length ? '$' + Math.max.apply(null, prices) : '—'; });
        $$('[data-chip]', scope).forEach(function (b) { var on = b.getAttribute('data-chip') === S.sub; if (b.classList.contains('mchip')) b.setAttribute('aria-pressed', on ? 'true' : 'false'); else onOff(b, on); });
        $$('[data-f="colour"]', scope).forEach(function (b) { b.style.boxShadow = b.getAttribute('data-v') === S.colour ? '0 0 0 2px #FBF8F4,0 0 0 3.5px #1A1714' : 'none'; });
        $$('[data-f="size"]', scope).forEach(function (b) { onOff(b, b.getAttribute('data-v') === S.size); });
        $$('[data-f="pack"]', scope).forEach(function (b) { var on = b.getAttribute('data-v') === S.pack, i = b.querySelector('i'); if (i) { i.style.background = on ? '#1A1714' : 'transparent'; i.style.borderColor = on ? '#1A1714' : '#D2C5B5'; } b.style.color = on ? '#1A1714' : '#4A443E'; });
        var nf = [S.colour, S.size, S.pack].filter(Boolean).length;
        $$('[data-act="clear-filters"]', scope).forEach(function (b) { if (b.textContent.trim() === 'Clear all') b.hidden = !nf; });
        $$('[data-filter-btn]', scope).forEach(function (b) { (b.querySelector('[data-filter-label]') || b).textContent = 'Filter' + (nf ? ' · ' + nf : ''); onOff(b, !!nf); });
        $$('[data-show-label]', scope).forEach(function (b) { b.textContent = 'Show ' + n + (n === 1 ? ' product' : ' products'); });
        $$('[data-sort-label]', scope).forEach(function (el) { el.textContent = SORT_N[S.sort]; });
        $$('[data-sort]', scope).forEach(function (b) {
          var on = b.getAttribute('data-sort') === S.sort, i = b.querySelector('i');
          b.style.fontWeight = on ? '600' : '400';
          if (i) i.style.background = on ? '#1A1714' : 'transparent'; else b.style.background = on ? '#F4EEE6' : 'transparent';
        });
      });
    }
    d.addEventListener('click', function (e) {
      var t;
      if ((t = e.target.closest('[data-chip]'))) { S.sub = t.getAttribute('data-chip'); S.shown = PAGE; apply(); }
      else if ((t = e.target.closest('[data-f]'))) { var k = t.getAttribute('data-f'), v = t.getAttribute('data-v'); S[k] = S[k] === v ? null : v; S.shown = PAGE; apply(); }
      else if ((t = e.target.closest('[data-sort]'))) { S.sort = t.getAttribute('data-sort'); S.shown = PAGE; apply(); show('sort', false); }
    });
    col = { clear: function () { S.colour = S.size = S.pack = null; S.shown = PAGE; apply(); }, more: function () { S.shown += 9; apply(); } };
    apply();
  })();

  /* ---------- product page: colour / size / pack → variant, gallery per colour, qty, add to bag */
  var pdp = null;
  (function () {
    var el = $('script[data-pdp]'); if (!el) return;
    var P = JSON.parse(el.textContent), VARS = JSON.parse($('script[data-variants]').textContent), OPTS = JSON.parse($('script[data-options]').textContent);
    /* 2026-09-19 (conversion audit, owner's decision): a sized product starts with no size chosen (P.si is null) - the
       shopper picks one before anything goes in the bag, because a wrong size costs a free replacement. A link that
       names a variant (?variant=, the way catalog ads and feeds link) still opens on that color and size. */
    var NEED_SIZE = P.sizes.length > 0;
    /* pack chooser (2026-09-16): a 2- or 3-pack is that many single packs in the bag, each with its own colour and
       size. Since 2026-10-24 (Chris) the pack prices are the store's automatic product discounts, a fixed amount off
       every piece once the bag holds that many of the product: PK.tiers = [[pieces, $ off each]], the largest tier
       reached applies - Shopify gives a line only one product discount, the biggest (the admin discounts are
       "<product> pack price (2+)" and "(3+)"). A page without data-packs JSON shows no chooser. */
    var PK = (function () { var e = $('script[data-packs]'); try { return e ? JSON.parse(e.textContent) : null; } catch (err) { return null; } })();
    /* 2026-10-24 (Chris): a page with the pack chooser opens on the 2-pack */
    var PACK0 = (PK && $('[data-packs] [data-pack="2"]')) ? 2 : 1;
    var S = { ci: P.ci, si: (NEED_SIZE && P.si == null) ? null : P.si, pi: P.pi, qty: 1, pack: PACK0, mix: false, items: [] };
    (function () {
      var id = param('variant'), hit = id && VARS.filter(function (v) { return String(v.id) === id; })[0];
      if (!hit) return;
      OPTS.forEach(function (name, i) {
        var val = hit.o[i];
        if (/^Colou?r$/.test(name)) P.colours.forEach(function (c, j) { if (c.n === val) S.ci = j; });
        else if (name === 'Size') P.sizes.forEach(function (z, j) { if (z.n === val) S.si = j; });
      });
    })();
    S.items = [{ ci: S.ci, si: S.si }];
    function sizeAt(si) { return (NEED_SIZE && si != null) ? P.sizes[Math.min(si, P.sizes.length - 1)] : null; }
    function cur() { return { c: P.colours[S.ci], s: sizeAt(S.si), k: P.packs.length ? P.packs[Math.min(S.pi, P.packs.length - 1)] : null }; }
    /* every pick has its size? (one size for the product, or one per row of a mixed pack) */
    function missing() {
      if (!NEED_SIZE) return false;
      if (S.pack > 1 && S.mix) return S.items.slice(0, S.pack).some(function (it) { return !it || it.si == null; });
      return S.si == null;
    }
    function variantFor(ci, si) {
      var c = P.colours[ci], s = sizeAt(si), k = P.packs.length ? P.packs[Math.min(S.pi, P.packs.length - 1)] : null;
      if (NEED_SIZE && !s) return null;
      return VARS.filter(function (v) {
        return OPTS.every(function (name, i) {
          var val = v.o[i];
          if (/^Colou?r$/.test(name)) return val === c.n;
          if (name === 'Size') return !!s && val === s.n;
          if (name === 'Pack') return !!k && val === k.n;
          return true;
        });
      })[0] || null;
    }
    function variant() { return variantFor(S.ci, S.si); }
    /* the pack price: n pieces, each less the largest per-piece amount the tiers give for n (the store's discounts) */
    function packOffEach(n) { var d = 0; if (PK && PK.tiers) PK.tiers.forEach(function (t) { if (n >= t[0]) d = Math.max(d, Math.round(t[1] * 100)); }); return d; }
    function packNet(unit, n) { return unit * n - packOffEach(n) * n; }
    function packPct(unit, n) { return unit > 0 ? Math.round(packOffEach(n) * 100 / unit) : 0; }
    function syncItems() {
      S.items[0] = { ci: S.ci, si: S.si };
      for (var i = 1; i < S.pack; i++) if (!S.items[i] || !S.mix) S.items[i] = { ci: S.ci, si: S.si };
      S.items.length = Math.max(1, S.pack);
    }
    function delivery(price) {
      /* the shipping policy, not a promised arrival date */
      return 'Ships in 1–5 business days from the US, 1–7 outside the US · ' + (price * S.qty >= FREE ? 'free shipping' : 'free shipping $75+');
    }
    function paint() {
      var x = cur(), v = variant(), price = v ? v.p : Math.round((x.k ? x.k.price : P.price) * 100);
      $$('[data-price]').forEach(function (e) { e.textContent = money(price); });
      $$('[data-lbl="colour"]').forEach(function (e) { e.textContent = x.c.n; });
      if (NEED_SIZE) $$('[data-lbl="size"]').forEach(function (e) { e.textContent = x.s ? x.s.label : 'Select a size'; });
      /* the phone layout (2026-10-16) says "Size · L" above the sizes and the chosen size's fit below them */
      if (NEED_SIZE) $$('[data-lbl="size-n"]').forEach(function (e) { e.textContent = x.s ? x.s.n : 'Select a size'; });
      $$('[data-lbl="size-fit"]').forEach(function (e) {
        var lb = (x.s && x.s.label) || '', pre = x.s ? x.s.n + ' · ' : '', fit = x.s && lb.indexOf(pre) === 0 ? x.s.n + ' fits ' + lb.slice(pre.length) : '';
        e.textContent = fit; e.hidden = !fit;
      });
      if (x.k) $$('[data-lbl="pack"]').forEach(function (e) { e.textContent = x.k.n; });
      /* the sticky bar on phones says what the button will add: color, size, how many, and that total (2026-09-19:
         it kept saying "1-pack · $65" beside an "Add 2-pack · $110" button) */
      var unitName = (PK && PK.unit) || '', total = (PK && S.pack > 1) ? packNet(price, S.pack) : price;
      var mixed = PK && S.pack > 1 && S.mix && S.items.slice(0, S.pack).some(function (it) { return it.ci !== S.items[0].ci || it.si !== S.items[0].si; });
      var summary = mixed ? S.pack + ' ' + unitName + 's · your mix'
        : [x.c.n, NEED_SIZE ? (x.s ? x.s.n : 'select a size') : null, PK ? S.pack + ' ' + unitName + (S.pack > 1 ? 's' : '') : (x.k && x.k.n)].filter(Boolean).join(' · ');
      $$('[data-lbl="variant"]').forEach(function (e) {
        e.textContent = summary;
        var pe = e.parentElement && e.parentElement.querySelector('[data-price]'); if (pe) pe.textContent = money(total);
      });
      $$('[data-pick="colour"]').forEach(function (b) { var on = +b.getAttribute('data-i') === S.ci; b.style.boxShadow = on ? '0 0 0 2px #FBF8F4,0 0 0 3.5px #1A1714' : 'none'; b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      ['size', 'pack'].forEach(function (k) {
        $$('[data-pick="' + k + '"]').forEach(function (b) { var on = +b.getAttribute('data-i') === (k === 'size' ? S.si : S.pi); b.style.borderColor = on ? '#1A1714' : '#D2C5B5'; b.style.background = on ? '#1A1714' : 'transparent'; b.style.color = on ? '#FBF8F4' : '#1A1714'; b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      });
      $$('[data-qty-val]').forEach(function (e) { e.textContent = S.qty; });
      $$('[data-delivery]').forEach(function (e) { e.textContent = delivery(price); });
      /* pack side labels, all from the live variant prices: the single pack shows its price, a multi-pack of it shows "Save ...", and when every option is a pack each shows its price per piece */
      var packPrice = function (k) { return VARS.filter(function (v) { return OPTS.every(function (name, j) { var val = v.o[j]; if (/^Colou?r$/.test(name)) return val === x.c.n; if (name === 'Size') return !!x.s && val === x.s.n; if (name === 'Pack') return val === k.n; return true; }); })[0]; };
      var single = P.packs.filter(function (q) { return parseInt(q.n, 10) === 1; })[0], singleV = single && packPrice(single);
      $$('[data-pick="pack"]').forEach(function (b) {
        var k = P.packs[+b.getAttribute('data-i')], side = b.querySelector('[data-pack-side]'), pv = k && packPrice(k);
        if (!side || !pv) return;
        var n = parseInt(k.n, 10) || 1;
        if (single) { if (n === 1 || !singleV) side.textContent = money(pv.p); else { var save = singleV.p * n - pv.p; side.textContent = save > 0 ? 'Save ' + money(save) : money(pv.p); } }
        else side.textContent = money(Math.round(pv.p / n)) + ' each';
      });
      /* sold out: buy buttons become "Notify me", the stock pill changes, unavailable sizes are struck through, the panel opens */
      var oos = !!v && !v.a, vlabel = [x.c.n, x.s && x.s.n, x.k && x.k.n].filter(Boolean).join(' · ');
      $$('[data-stock]').forEach(function (e) { if (e.hasAttribute('data-stock-oos')) e.hidden = !oos; if (!e.dataset.stockText) e.dataset.stockText = e.textContent; e.textContent = oos ? 'Sold out · Back soon' : e.dataset.stockText; e.style.background = oos ? '#F8EFDD' : '#E3EFEA'; e.style.color = oos ? '#B07A1C' : '#2A7A64'; });
      /* keep Shopify's express checkout button on the chosen variant, and hide it when that variant is sold out */
      $$('[data-pb-id]').forEach(function (e) { if (v) e.value = v.id; });
      $$('[data-pb-form]').forEach(function (f) { f.style.display = (v && v.a) ? '' : 'none'; });
      $$('[data-act="add-to-bag"],[data-act="notify"]').forEach(function (b) {
        if (!b.dataset.html) { b.dataset.html = b.innerHTML; b.dataset.bg = b.style.background || ''; b.dataset.fg = b.style.color || ''; }
        if (oos) { b.setAttribute('data-act', 'notify'); b.textContent = 'Sold out · Notify me'; b.style.background = '#F4EEE6'; b.style.color = '#1A1714'; }
        else { b.setAttribute('data-act', 'add-to-bag'); b.innerHTML = b.dataset.html; b.style.background = b.dataset.bg || ''; b.style.color = b.dataset.fg || ''; $$('[data-price]', b).forEach(function (e) { e.textContent = money(price); }); }
      });
      $$('[data-pick="size"]').forEach(function (b) {
        var sz = P.sizes[+b.getAttribute('data-i')]; if (!sz) return;
        var any = VARS.some(function (vv) { return vv.a && OPTS.every(function (name, jj) { var val = vv.o[jj]; if (/^Colou?r$/.test(name)) return val === x.c.n; if (name === 'Size') return val === sz.n; return true; }); });
        b.style.opacity = any ? '' : '.45'; b.style.textDecoration = any ? '' : 'line-through';
        /* a size this color is not made in (XS and XXL are Black only) cannot be picked; a sold-out one still can,
           so its restock form opens */
        var made = !!variantFor(S.ci, +b.getAttribute('data-i'));
        b.setAttribute('aria-disabled', made ? 'false' : 'true');
        b.title = made ? (any ? '' : 'Sold out') : 'Not made in ' + x.c.n;
      });
      $$('[data-el="oos"]').forEach(function (e) { e.hidden = !oos; });
      $$('[data-oos-variant]').forEach(function (e) { e.value = vlabel; });
      $$('[data-oos-sku]').forEach(function (e) { e.value = v ? (v.sku || '') : ''; });
      $$('[data-oos-vid]').forEach(function (e) { e.value = v ? String(v.id) : ''; });
      $$('[data-oos-mail]').forEach(function (a) { a.href = 'mailto:support@cladostomy.com?subject=' + encodeURIComponent('Restock request: ' + P.name + ' · ' + vlabel) + '&body=' + encodeURIComponent('Hi, please let me know when ' + P.name + ' (' + vlabel + (v && v.sku ? ', ' + v.sku : '') + ') is back in stock.'); });
      paintPacks(price);
      /* no size yet: the button says so, and a tap on it leads to the size row (pdp.add) instead of adding */
      if (missing()) $$('[data-act="add-to-bag"]').forEach(function (b) { b.textContent = S.pack > 1 && S.mix ? 'Select a size for each' : 'Select a size'; });
    }
    function askSize() {
      var vis = function (e) { return e.getBoundingClientRect().width > 0; };
      var rows = $$('[data-pack-row]').filter(vis).filter(function (r) { var it = S.items[+r.getAttribute('data-pack-row')]; return !it || it.si == null; });
      var btn = $$('[data-pick="size"]').filter(vis)[0], target = (S.pack > 1 && S.mix && rows[0]) || (btn && btn.parentElement);
      toast(S.pack > 1 && S.mix ? 'Select a size for each one first' : 'Select a size first');
      if (!target) return;
      target.scrollIntoView({ block: 'center', behavior: 'smooth' });
      target.style.transition = 'box-shadow 200ms'; target.style.borderRadius = '14px'; target.style.boxShadow = '0 0 0 6px #FBF8F4, 0 0 0 8px #F2583B';
      setTimeout(function () { target.style.boxShadow = ''; }, 1800);
    }
    /* ---- pack chooser */
    function paintPacks(unit) {
      if (!PK) return;
      var n = S.pack, gross = unit * n, net = packNet(unit, n), save = gross - net;
      $$('[data-packs]').forEach(function (box) {
        $$('[data-pack]', box).forEach(function (b) {
          var bn = +b.getAttribute('data-pack'), bgross = unit * bn, bnet = packNet(unit, bn), bsave = bgross - bnet, on = bn === n;
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
          b.style.borderColor = on ? '#1A1714' : '#E6DDD2';
          b.style.background = on ? '#FFFFFF' : '#FBF8F4';
          b.style.boxShadow = on ? '0 0 0 1px #1A1714' : 'none';
          var r = $('[data-pack-radio]', b);
          if (r) { r.style.borderColor = on ? '#1A1714' : '#D2C5B5'; r.style.background = on ? '#1A1714' : 'transparent'; r.style.boxShadow = on ? 'inset 0 0 0 3px #FBF8F4' : 'none'; }
          var pe = $('[data-pack-price]', b); if (pe) pe.textContent = money(bnet);
          var we = $('[data-pack-was]', b); if (we) { we.textContent = money(bgross); we.hidden = !bsave; }
          var bd = $('[data-pack-badge]', b), sv = $('[data-pack-save]', b);
          if (bd && sv) {
            /* the saving rides in the badge, or (the narrow phone cards, 2026-10-16) has its own line beside the was-price */
            var inBadge = bd.contains(sv), lbl = (bd.childNodes[0] && bd.childNodes[0].nodeType === 3) ? bd.childNodes[0].textContent.trim() : '';
            sv.textContent = bsave ? ((lbl && inBadge ? ' · ' : '') + 'Save ' + packPct(unit, bn) + '%') : '';
            if (!inBadge) sv.hidden = !bsave;
            bd.hidden = !(lbl || (inBadge && bsave));
          }
          var ee = $('[data-pack-each]', b);
          if (ee) {
            /* the per-piece price and free shipping are the reason to take a bigger pack: both are called out. The parts
               are tagged (data-pe) so the phone cards can stack them and drop "free over $75" */
            /* 2026-10-25 (Chris): only the number of "$47.50 per wrap" is bold and larger ([data-pe-num] in
               clad.css.liquid); "per wrap" keeps its small grey size and stays together, so a narrow phone card
               breaks the line as "$47.50 / per wrap" rather than leaving "wrap" alone */
            var per = bn > 1 ? '<span data-pe="per"><b data-pe-num>' + money(Math.round(bnet / bn)) + '</b> per&nbsp;' + escHtml((PK && PK.unit) || 'item') + '</span>' : '';
            /* below the free-shipping line the flat rate is said here, not first at checkout (2026-09-19) */
            var ship = bnet >= FREE ? '<span data-pe="ship"><b style="font-weight:600;color:#2A7A64">✓ Free shipping</b></span>'
              : '<span data-pe="ship"><b style="font-weight:600;color:#F2583B">+ ' + money(SHIP) + ' US shipping</b><span data-pe="free" style="color:#8A8178"> · free over ' + money(FREE) + '</span></span>';
            ee.innerHTML = per + (per && ship ? '<span data-pe="sep"> <span style="color:#D2C5B5">·</span> </span>' : '') + ship;
          }
        });
        var cus = $('[data-pack-custom]', box); if (cus) cus.hidden = n < 2;
        var cl = $('[data-pack-custom-label]', box), TP = pickerTpl(box);
        /* one colour is not a choice: the line then only offers the size */
        if (cl) cl.textContent = 'Pick a ' + (TP.colour.length > 1 ? (TP.size.length ? 'color and size' : 'color') : 'size') + ' for each ' + ((PK && PK.unit) || 'item');
        $$('[data-pack-mode]', box).forEach(function (b) {
          var on = (b.getAttribute('data-pack-mode') === 'mix') === S.mix;
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
          b.style.borderColor = on ? '#1A1714' : '#D2C5B5'; b.style.background = on ? '#1A1714' : 'transparent'; b.style.color = on ? '#FBF8F4' : '#1A1714';
        });
        var tot = $('[data-pack-total]', box);
        if (tot) {
          tot.hidden = n < 2;
          var tw = $('[data-pack-total-was]', tot), tn = $('[data-pack-total-now]', tot), ts = $('[data-pack-total-save]', tot);
          if (tw) { tw.textContent = money(gross); tw.hidden = !save; }
          if (tn) tn.textContent = money(net);
          if (ts) ts.textContent = save ? 'Save ' + money(save) : '';
        }
        buildRows(box);
      });
      $$('[data-qty]').forEach(function (b) { if (b.parentElement) b.parentElement.style.display = n > 1 ? 'none' : ''; });
      if (n > 1) $$('[data-act="add-to-bag"]').forEach(function (b) { b.innerHTML = 'Add ' + n + '-pack to bag · <span data-price>' + money(net) + '</span>'; });
    }
    function pickerTpl(box) {
      if (!box._pktpl) {
        var scope = box.closest('.dsk,.mob') || d;
        box._pktpl = { colour: $$('[data-pick="colour"]', scope).map(function (b) { return b.cloneNode(true); }),
                       size: $$('[data-pick="size"]', scope).map(function (b) { return b.cloneNode(true); }) };
      }
      return box._pktpl;
    }
    function buildRows(box) {
      var wrap = $('[data-pack-rows]', box); if (!wrap) return;
      wrap.hidden = !(S.mix && S.pack > 1);
      if (wrap.hidden) { wrap.innerHTML = ''; return; }
      var T = pickerTpl(box), unit = (PK && PK.unit) || 'item';
      if (wrap.children.length !== S.pack) {
        wrap.innerHTML = '';
        for (var i = 0; i < S.pack; i++) {
          var row = d.createElement('div');
          row.setAttribute('data-pack-row', String(i));
          row.style.cssText = 'display:flex;flex-direction:column;gap:8px;padding-top:10px;border-top:1px solid #E6DDD2';
          var h = d.createElement('span');
          h.style.cssText = 'font-size:12.5px;font-weight:600;color:#1A1714';
          h.textContent = unit.charAt(0).toUpperCase() + unit.slice(1) + ' ' + (i + 1);
          row.appendChild(h);
          ['colour', 'size'].forEach(function (kind) {
            if (!T[kind].length) return;
            var strip = d.createElement('div');
            strip.style.cssText = 'display:flex;gap:' + (kind === 'colour' ? '10px' : '8px') + ';flex-wrap:wrap';
            T[kind].forEach(function (b) {
              var c = b.cloneNode(true);
              c.removeAttribute('data-pick');
              c.setAttribute('data-pack-pick', kind);
              c.setAttribute('data-row', String(i));
              strip.appendChild(c);
            });
            row.appendChild(strip);
          });
          wrap.appendChild(row);
        }
      }
      $$('[data-pack-row]', wrap).forEach(function (row) {
        var i = +row.getAttribute('data-pack-row'), it = S.items[i] || { ci: S.ci, si: S.si };
        $$('[data-pack-pick="colour"]', row).forEach(function (b) { var onc = +b.getAttribute('data-i') === it.ci; b.style.boxShadow = onc ? '0 0 0 2px #FBF8F4,0 0 0 3.5px #1A1714' : 'none'; b.setAttribute('aria-pressed', onc ? 'true' : 'false'); });
        $$('[data-pack-pick="size"]', row).forEach(function (b) {
          var j = +b.getAttribute('data-i'), on = j === it.si, vv = variantFor(it.ci, j), okv = !!(vv && vv.a);
          b.style.borderColor = on ? '#1A1714' : '#D2C5B5'; b.style.background = on ? '#1A1714' : 'transparent'; b.style.color = on ? '#FBF8F4' : '#1A1714';
          b.style.opacity = okv ? '' : '.45'; b.style.textDecoration = okv ? '' : 'line-through';
          b.setAttribute('aria-pressed', on ? 'true' : 'false'); b.setAttribute('aria-disabled', vv ? 'false' : 'true');
          b.title = vv ? (okv ? '' : 'Sold out') : 'Not made in ' + P.colours[it.ci].n;
        });
      });
    }
    /* gallery */
    /* 2026-09-19: the page data lists the gallery's clips (P.videos: slot, files, cover) - the wrap opens with two */
    function clips() { return (P.videos || (P.video ? [P.video] : [])).slice().sort(function (a, b) { return (a.at || 0) - (b.at || 0); }); }
    function items() { var x = cur(), list = x.c.gal.map(function (g) { return { src: g[0], alt: g[1] }; }); clips().forEach(function (v) { list.splice(v.at || 0, 0, { video: v }); }); return list; }
    function galleries() { return $$('[data-gal-track]').map(function (track) { return { track: track, scope: track.closest('.dsk,.mob') || d, wrap: track.parentElement }; }); }
    function tplOf(track) {
      if (!track._tpl) {
        var img = track.querySelector('[data-gal-slide] img'), vid = track.querySelector('[data-gal-slide] video');
        track._tpl = { img: img ? img.closest('[data-gal-slide]').cloneNode(true) : null, video: vid ? vid.closest('[data-gal-slide]').cloneNode(true) : null };
      }
      return track._tpl;
    }
    function thumbTpl(scope) {
      var box = $('[data-thumbs]', scope); if (!box) return null;
      if (!box._tpl) { var btns = $$('button', box); var im = btns.filter(function (b) { return !b.querySelector('svg'); })[0], vd = btns.filter(function (b) { return b.querySelector('svg'); })[0]; box._tpl = { img: im && im.cloneNode(true), video: vd && vd.cloneNode(true) }; }
      return box._tpl;
    }
    function dotTpl(scope) { var box = $('[data-dots]', scope); if (!box) return null; if (!box._tpl) { var b = box.querySelector('button'); box._tpl = b && b.cloneNode(true); } return box._tpl; }
    function go(g, i) {
      var n = g.track.children.length; i = Math.max(0, Math.min(n - 1, i)); g.track._i = i;
      g.track.style.transform = 'translateX(-' + (i * 100) + '%)';
      $$('[data-gal-count]', g.wrap).forEach(function (e) { e.textContent = (i + 1) + ' / ' + n; });
      $$('[data-thumb]', g.scope).forEach(function (b) { var on = +b.getAttribute('data-thumb') === i; b.style.boxShadow = on ? 'inset 0 0 0 2px #1A1714' : 'none'; var im = b.querySelector('img'); if (im) im.style.opacity = on ? '1' : '0.7'; });
      $$('[data-dot] i', g.scope).forEach(function (dot) { var on = +dot.parentElement.getAttribute('data-dot') === i; dot.style.background = on ? '#1A1714' : '#D2C5B5'; dot.parentElement.setAttribute('aria-current', on ? 'true' : 'false'); });
    }
    /* 2026-09-12 perf: rebuilt slides keep the responsive srcset (sizes come with the slide template), only the first
       loads eagerly, thumbnails ask the CDN for 240 px */
    function withW(u, w) { return u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=' + w; }
    function ladder(u) { return [360, 540, 720, 1024].map(function (w) { return withW(u, w) + ' ' + w + 'w'; }).join(', ') + ', ' + u + ' 2048w'; }
    function rebuild() {
      var list = items();
      galleries().forEach(function (g) {
        var T = tplOf(g.track); g.track.innerHTML = '';
        list.forEach(function (it, i) {
          var n = (it.video ? T.video : T.img).cloneNode(true);
          if (!it.video) {
            var im = n.querySelector('img'); im.src = it.src; im.alt = it.alt;
            if (im.hasAttribute('srcset')) im.srcset = ladder(it.src);
            if (i === 0) { im.removeAttribute('loading'); im.setAttribute('fetchpriority', 'high'); } else { im.setAttribute('loading', 'lazy'); im.removeAttribute('fetchpriority'); }
          } else {
            /* each clip gets its own files and shape on the cloned slide: the square lead loop fills the frame, has no
               native controls (a tap toggles it) and shows its cover at once; the 16:9 demo keeps its controls. A gallery
               marked data-fill (the phone layout, 2026-10-16) gives every clip the square treatment: no letterbox bands */
            var ve = n.querySelector('video'), v = it.video, sq = v.square || g.wrap.hasAttribute('data-fill');
            if (ve && v.src) {
              ve.src = v.src;
              if (v.sd) ve.setAttribute('data-src-sd', v.sd); else ve.removeAttribute('data-src-sd');
              /* the clip that leads keeps its cover in data-cover, sized for this layout; covers() below makes it the
                 poster only in the layout that is displayed (a poster in the hidden half would be fetched too) */
              var lead = i === 0, cw = lead && g.scope.classList && g.scope.classList.contains('mob') ? 750 : 1080, cover = v.poster ? withW(v.poster, cw) : '';
              ve.removeAttribute('poster'); ve.removeAttribute('data-poster'); ve.removeAttribute('data-cover');
              ve.setAttribute(lead ? 'data-cover' : 'data-poster', cover);
              if (lead) ve.setAttribute('data-lead-video', ''); else ve.removeAttribute('data-lead-video');
              ve.controls = !sq;
              if (sq) ve.setAttribute('data-tap-play', ''); else ve.removeAttribute('data-tap-play');
              ve.style.aspectRatio = sq ? '1/1' : '16/9'; ve.style.height = sq ? '100%' : ''; ve.style.objectFit = sq ? 'cover' : 'contain'; ve.style.background = sq ? '#F4EEE6' : '#1A1714';
              ve.setAttribute('aria-label', v.alt || '');
            }
          }
          g.track.appendChild(n);
        });
        covers(); watchVideos(g.track);
        var tb = $('[data-thumbs]', g.scope), TT = thumbTpl(g.scope);
        if (tb && TT) { tb.innerHTML = ''; list.forEach(function (it, i) { var n = (it.video ? TT.video : TT.img).cloneNode(true); n.setAttribute('data-thumb', i); var tim = n.querySelector('img'); if (!it.video) { tim.src = withW(it.src, 240); n.setAttribute('aria-label', it.alt); } else if (it.video.poster) { if (tim) tim.src = withW(it.video.poster, 240); n.setAttribute('aria-label', it.video.alt || ''); } tb.appendChild(n); }); }
        var db = $('[data-dots]', g.scope), DT = dotTpl(g.scope);
        if (db && DT) { db.innerHTML = ''; list.forEach(function (it, i) { var n = DT.cloneNode(true); n.setAttribute('data-dot', i); n.setAttribute('aria-label', (i + 1) + ' / ' + list.length); db.appendChild(n); }); }
        go(g, 0);
      });
    }
    function galleryFor(t) { return galleries().filter(function (x) { return x.scope.contains(t); })[0]; }
    d.addEventListener('click', function (e) {
      var t;
      if ((t = e.target.closest('[data-pick]'))) {
        var k = t.getAttribute('data-pick'), i = +t.getAttribute('data-i');
        if (k === 'colour') {
          if (S.ci !== i) { S.ci = i; if (S.si != null && !variantFor(S.ci, S.si)) S.si = null; rebuild(); }   /* the size may not be made in the new color */
        } else if (k === 'size') {
          if (!variantFor(S.ci, i)) { toast(P.sizes[i].n + ' is not made in ' + P.colours[S.ci].n); return; }
          S.si = i;
        } else S.pi = i;
        syncItems(); paint();
      }
      else if ((t = e.target.closest('[data-pack]'))) { S.pack = +t.getAttribute('data-pack') || 1; if (S.pack < 2) S.mix = false; S.qty = 1; syncItems(); paint(); }
      else if ((t = e.target.closest('[data-pack-mode]'))) { S.mix = t.getAttribute('data-pack-mode') === 'mix'; syncItems(); paint(); }
      else if ((t = e.target.closest('[data-pack-pick]'))) {
        var pr = +t.getAttribute('data-row'), pk = t.getAttribute('data-pack-pick'), pj = +t.getAttribute('data-i');
        S.items[pr] = S.items[pr] || { ci: S.ci, si: S.si };
        if (pk === 'colour') { S.items[pr].ci = pj; if (S.items[pr].si != null && !variantFor(pj, S.items[pr].si)) S.items[pr].si = null; }
        else {
          if (!variantFor(S.items[pr].ci, pj)) { toast(P.sizes[pj].n + ' is not made in ' + P.colours[S.items[pr].ci].n); return; }
          S.items[pr].si = pj;
        }
        if (pr === 0) { if (S.ci !== S.items[0].ci) { S.ci = S.items[0].ci; rebuild(); } S.si = S.items[0].si; }
        paint();
      }
      else if ((t = e.target.closest('[data-qty]'))) { S.qty = Math.max(1, S.qty + (+t.getAttribute('data-qty'))); paint(); }
      else if ((t = e.target.closest('[data-gal]'))) { var g = galleryFor(t); if (g) go(g, (g.track._i || 0) + (+t.getAttribute('data-gal'))); }
      else if ((t = e.target.closest('[data-thumb]'))) { var g2 = galleryFor(t); if (g2) go(g2, +t.getAttribute('data-thumb')); }
      else if ((t = e.target.closest('[data-dot]'))) { var g3 = galleryFor(t); if (g3) go(g3, +t.getAttribute('data-dot')); }
    });
    /* the lead clip has no native controls: a tap plays or pauses it (not the tap that ends a swipe) */
    var swiped = 0;
    d.addEventListener('click', function (e) {
      var tv = e.target.closest && e.target.closest('video[data-tap-play]');
      if (!tv || Date.now() - swiped < 400) return;
      if (tv.paused) { tv.muted = true; var pp = tv.play(); if (pp && pp.catch) pp.catch(function () {}); } else tv.pause();
    });
    galleries().forEach(function (g) {
      tplOf(g.track); thumbTpl(g.scope); dotTpl(g.scope); go(g, 0);
      var x0 = null;
      /* a swipe may start on a video too (2026-09-19: the gallery opens with one) - only the strip of a video's
         native control bar is left to the player */
      g.wrap.addEventListener('pointerdown', function (e) {
        if (e.target.closest('button')) return;
        var pv = e.target.closest('video');
        if (pv && pv.controls && e.clientY > pv.getBoundingClientRect().bottom - 64) return;
        x0 = e.clientX;
      });
      g.wrap.addEventListener('pointerup', function (e) { if (x0 == null) return; var dx = e.clientX - x0; x0 = null; if (Math.abs(dx) > 8) swiped = Date.now(); if (Math.abs(dx) > 40) go(g, (g.track._i || 0) + (dx < 0 ? 1 : -1)); });
      g.wrap.addEventListener('pointercancel', function () { x0 = null; });
    });
    pdp = {
      add: function () {
        var list = [];
        if (missing()) { askSize(); return; }
        if (S.pack > 1) {
          var map = {}, order = [], bad = false;
          S.items.slice(0, S.pack).forEach(function (it) {
            var vv = variantFor(it.ci, it.si);
            if (!vv || !vv.a) { bad = true; return; }
            if (!map[vv.id]) order.push(vv.id);
            map[vv.id] = (map[vv.id] || 0) + 1;
          });
          if (bad) { toast('One of the picks is sold out'); return; }
          list = order.map(function (id) { return { id: +id, quantity: map[id] }; });
        } else {
          var v = variant();
          if (!v) { toast('Please choose your options'); return; }
          if (!v.a) { toast('Sold out in this option'); return; }
          list = [{ id: v.id, quantity: S.qty }];
        }
        var btns = $$('[data-act="add-to-bag"]'); btns.forEach(function (b) { b.style.opacity = '.6'; });
        addItems(list).then(function () { S.qty = 1; paint(); show('bag', true); })
          .catch(function (err) { toast(err.message || 'Could not add to bag'); })
          .then(function () { btns.forEach(function (b) { b.style.opacity = ''; }); });
      }
    };
    if (P.rebuild || S.ci !== P.ci) rebuild();      /* a ?variant= link may have opened another color */
    syncItems();                                     /* the items list follows the opening pack (2-pack since 2026-10-24) */
    paint();
  })();

  /* ---------- action dispatcher */
  d.addEventListener('click', function (e) {
    var a = e.target.closest('[data-act]'); if (!a) return;
    var act = a.getAttribute('data-act');
    e.preventDefault();
    switch (act) {
      case 'open-bag': show('menu', false); show('bag', true); break;
      case 'close-bag': show('bag', false); break;
      case 'open-menu': show('menu', true); break;
      case 'close-menu': show('menu', false); break;
      case 'toggle-contact': show('contact', !isOpen('contact')); break;
      case 'close-contact': show('contact', false); break;
      case 'open-popup': show('popup', true); break;
      case 'close-popup': show('popup', false); popupSeen(); break;
      case 'copy-code':
        var codeEl = a.parentElement.querySelector('[data-nl-code]'), code = codeEl ? codeEl.textContent.trim() : (KL.code || '');
        (navigator.clipboard && navigator.clipboard.writeText ? navigator.clipboard.writeText(code) : Promise.reject()).then(function () { a.textContent = 'Copied'; toast('Code copied: ' + code); }, function () { if (codeEl) { var sel = window.getSelection(), rg = d.createRange(); rg.selectNodeContents(codeEl); sel.removeAllRanges(); sel.addRange(rg); } });
        break;
      case 'open-filter': show('filter', true); break;
      case 'close-filter': show('filter', false); break;
      case 'open-sort': show('sort', true); break;
      case 'close-sort': show('sort', false); break;
      case 'toggle-sort': show('sort', !isOpen('sort')); break;
      case 'bag-dec': changeQty(a.getAttribute('data-key'), -1); break;
      case 'bag-inc': changeQty(a.getAttribute('data-key'), 1); break;
      case 'bag-remove': changeQty(a.getAttribute('data-key'), -1e9); break;
      case 'clear-filters': if (col) col.clear(); break;
      case 'load-more': if (col) col.more(); break;
      case 'add-to-bag': if (pdp) pdp.add(); break;
      case 'upsell-add': upsellAdd(a); break;
      case 'upsell-hide': upsellHide(); break;
      case 'notify':
        var pnl = $$('[data-el="oos"]').filter(function (e) { return e.offsetParent !== null; })[0];
        if (pnl) { pnl.scrollIntoView({ block: 'center', behavior: 'smooth' }); var inp = pnl.querySelector('input[type="email"]'); if (inp) setTimeout(function () { inp.focus(); }, 400); }
        break;
      case 'toggle-chart':
        /* the chart sits beside its toggle, or (the phone layout, 2026-10-16) further down the same size block: the
           "Size guide" link opens and closes it, and so does the Close button at its foot */
        var ch = a.parentElement.querySelector('[data-el="chart"]'), cbx = !ch && a.closest('[data-chart-box]');
        if (cbx) ch = cbx.querySelector('[data-el="chart"]');
        if (ch) {
          ch.hidden = !ch.hidden;
          if (cbx) $$('[data-act="toggle-chart"][aria-expanded]', cbx).forEach(function (t) { t.setAttribute('aria-expanded', ch.hidden ? 'false' : 'true'); });
          var ii = a.querySelector('i'); if (ii) ii.style.transform = ch.hidden ? 'rotate(45deg)' : 'rotate(-135deg)';
          /* closed from its foot, the long chart folds away above the screen: the sizes come back into view */
          if (ch.hidden && cbx && ch.contains(a) && cbx.getBoundingClientRect().top < 80) cbx.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
        break;
    }
  });

  /* ---------- demo videos (perf audit 2026-09-11, P0-1): nothing downloads until a video is half on screen, phones
     get Shopify's 480p rendition, and off screen they pause. Reduced motion: no autoplay (the controls still work). */
  var vio, pio;
  function watchVideos(root) {
    /* posters (data-poster, see build_perf.py) load once a video is within ~800 px of view; videos in the hidden half never load one */
    var posters = $$('video[data-poster]', root || d);
    if ('IntersectionObserver' in window) {
      pio = pio || new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          var v = e.target; pio.unobserve(v);
          if (v.getAttribute('data-poster')) { v.poster = v.getAttribute('data-poster'); v.removeAttribute('data-poster'); }
        });
      }, { rootMargin: '800px' });
      posters.forEach(function (v) { pio.observe(v); });
    } else posters.forEach(function (v) { v.poster = v.getAttribute('data-poster'); });
    if (!('IntersectionObserver' in window) || (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
    function start(v) {
      var sd = v.getAttribute('data-src-sd');
      if (sd && innerWidth < 900 && !v._sd) { v._sd = 1; v.src = sd; }
      v.muted = true; v.preload = 'auto';
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    }
    /* 2026-09-19 (page speed): the clip that leads a gallery is on screen from the first moment, so it used to start
       downloading beside its own cover - the page's largest paint - and on a slow connection the two fought for the
       line. It now waits until the cover is in, plus a beat for the paint (4 s at most, should the cover fail). */
    function afterCover(v, cb) {
      if (v._cover) return cb();
      var u = v.getAttribute('data-cover') || v.poster, done = function () { if (v._cover) return; v._cover = 1; setTimeout(cb, 350); };
      if (!u) { v._cover = 1; return cb(); }
      var im = new Image(); im.onload = im.onerror = done; im.src = u; setTimeout(done, 4000);
    }
    vio = vio || new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        v._on = e.isIntersecting && e.intersectionRatio >= 0.5 && !document.hidden;
        if (v._on) { if (v.hasAttribute('data-lead-video')) afterCover(v, function () { if (v._on) start(v); }); else start(v); }
        else if (!v.paused) v.pause();
      });
    }, { threshold: [0, 0.5] });
    $$('video[data-autoplay]', root || d).forEach(function (v) { if (!v._watched) { v._watched = 1; vio.observe(v); } });
  }
  /* a gallery's lead clip names its cover in data-cover, sized for its layout. An inline script makes it the poster
     in the layout that is displayed as the parser passes it (build_pdp_gallery.py); this does the same for a viewport
     that later crosses the 900 px breakpoint and for galleries rebuilt after a color change */
  function covers() {
    $$('video[data-cover]').forEach(function (v) {
      var h = v.closest('.dsk,.mob');
      if ((!h || getComputedStyle(h).display !== 'none') && !v.getAttribute('poster')) v.poster = v.getAttribute('data-cover');
    });
  }
  covers();
  if (window.matchMedia) { var mq900 = matchMedia('(min-width:900px)'); if (mq900.addEventListener) mq900.addEventListener('change', covers); }
  watchVideos();

  /* ---------- customer videos carousel (2026-10-24, snippets/customer-videos.liquid): the middle card plays muted,
     the others wait with their posters; arrows, a swipe or a tap on a side card move along; a tap on the middle card
     pauses it; the speaker button turns its sound on (a tap, so the browser allows it). Off screen, in a hidden tab,
     or in the layout that is not displayed, nothing plays or downloads (preload="none" until the first play).
     Reduced motion: no autoplay, a tap plays. */
  (function () {
    var still = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    $$('[data-cv]').forEach(function (sec) {
      var track = $('[data-cv-track]', sec), cards = $$('[data-cv-card]', sec);
      if (!track || !cards.length) return;
      var i = 0, muted = true, visible = false, raf = null;
      function vid(c) { return c.querySelector('video'); }
      function shown() { return sec.getBoundingClientRect().width > 0; }
      function stop(c) { var v = vid(c); if (!v.paused) v.pause(); c.classList.remove('is-playing'); }
      function paint() {
        cards.forEach(function (c, k) {
          var on = k === i, v = vid(c), sb = c.querySelector('[data-cv-sound]');
          c.classList.toggle('is-on', on);
          if (on) {
            v.muted = muted;
            /* the play badge only when the clip is really stopped: paused by a tap, reduced motion before a tap, or
               a play() the browser refused - not while a clip is still loading */
            if (visible && !c.classList.contains('is-paused') && !(still && !c.classList.contains('is-tapped'))) {
              v.preload = 'auto';
              var p = v.play(); if (p && p.catch) p.catch(function () { c.classList.remove('is-playing'); c.classList.add('is-paused'); });
            } else if (still && !c.classList.contains('is-tapped')) c.classList.add('is-paused');
          } else { stop(c); v.muted = true; }
          if (sb) { sb.setAttribute('aria-pressed', on && !muted ? 'true' : 'false'); sb.setAttribute('aria-label', on && !muted ? 'Turn the sound off' : 'Turn the sound on'); }
        });
        var n = $('[data-cv-who-name]', sec), cp = $('[data-cv-who-caption]', sec);
        if (n) n.textContent = cards[i].getAttribute('data-cv-name') || '';
        if (cp) cp.textContent = cards[i].getAttribute('data-cv-caption') || '';
      }
      cards.forEach(function (c) {
        var v = vid(c);
        v.addEventListener('playing', function () { c.classList.add('is-playing'); });
        v.addEventListener('pause', function () { c.classList.remove('is-playing'); });
      });
      function nearest() {
        var r0 = track.getBoundingClientRect(), mid = r0.left + r0.width / 2, best = 0, bd = Infinity;
        cards.forEach(function (c, k) { var r = c.getBoundingClientRect(), dd = Math.abs(r.left + r.width / 2 - mid); if (dd < bd) { bd = dd; best = k; } });
        return best;
      }
      function go(k, now) {
        k = Math.max(0, Math.min(cards.length - 1, k));
        var c = cards[k], left = c.offsetLeft - (track.clientWidth - c.offsetWidth) / 2;
        if (now || !track.scrollTo) track.scrollLeft = left; else track.scrollTo({ left: left, behavior: 'smooth' });
        if (k !== i) { i = k; paint(); }
      }
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = null; var k = nearest(); if (k !== i) { i = k; paint(); } });
      });
      sec.addEventListener('click', function (e) {
        var t;
        if ((t = e.target.closest('[data-cv-step]'))) { go(i + (+t.getAttribute('data-cv-step'))); return; }
        if ((t = e.target.closest('[data-cv-sound]'))) { muted = !muted; paint(); return; }
        if ((t = e.target.closest('[data-cv-card]'))) {
          var k = cards.indexOf(t);
          if (k !== i) { go(k); return; }
          t.classList.add('is-tapped');
          if (vid(t).paused) { t.classList.remove('is-paused'); paint(); } else { t.classList.add('is-paused'); stop(t); }
        }
      });
      function pauseAll() { cards.forEach(stop); }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (en) { visible = en.isIntersecting && en.intersectionRatio >= 0.35 && shown(); if (visible) paint(); else pauseAll(); });
        }, { threshold: [0, 0.35] }).observe(track);
      } else { visible = shown(); }
      d.addEventListener('visibilitychange', function () { if (d.hidden) pauseAll(); else if (visible) paint(); });
      go(0, true); paint();
    });
  })();

  /* ---------- contact forms: after Shopify redirects back with ?contact_posted=true, scroll to the confirmation */
  if (/contact_posted=true/.test(location.search)) { var posted = $('[data-posted]'); if (posted) setTimeout(function () { posted.scrollIntoView({ block: 'center' }); }, 200); }

  loadCart().catch(function () {});
  window.clad = { loadCart: loadCart, toast: toast, show: show, money: money };
})();

/* 2026-09-12: homepage hero video. Only the cut in the visible half (desktop / mobile) loads and plays, so a phone
   never downloads the desktop file; it pauses off screen and in background tabs; reduced motion and Save-Data keep
   the still poster; the round button pauses and resumes. */
(function () {
  var vids = [].slice.call(document.querySelectorAll('video[data-hero-video]'));
  if (!vids.length) return;
  var conn = navigator.connection || {};
  var paused = !!((window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) || conn.saveData || /2g|3g/.test(conn.effectiveType || ''));
  var armed = false;   /* starts only once the page has loaded and the browser is idle (perf audit 4.6) */
  var ICON = {
    pause: '<svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor" aria-hidden="true"><path d="M7 5h3.5v14H7zM13.5 5H17v14h-3.5z"></path></svg>',
    play: '<svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor" aria-hidden="true"><path d="M8 5.5v13l10.5-6.5z"></path></svg>'
  };
  /* which cut is on screen comes from the breakpoint, not from getClientRects(): reading layout while the page was still
     being built forced a full reflow at startup (PageSpeed 2026-09-14, "forced reflow" in clad.js) */
  function sync() {
    var mob = window.matchMedia ? matchMedia('(max-width:899px)').matches : innerWidth < 900;
    vids.forEach(function (v) {
      var shown = !!v.closest(mob ? '.mob' : '.dsk') && v._in !== false;
      if (shown && !paused && armed && !document.hidden) {
        v.muted = true;
        if (v.preload !== 'auto') v.preload = 'auto';
        if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      } else if (!v.paused) v.pause();
      var b = v.parentNode.querySelector('[data-hero-toggle]');
      if (b) {
        b.hidden = false;
        b.setAttribute('aria-pressed', paused ? 'true' : 'false');
        b.setAttribute('aria-label', paused ? 'Play background video' : 'Pause background video');
        b.innerHTML = paused ? ICON.play : ICON.pause;
      }
    });
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { e.target._in = e.isIntersecting; }); sync(); });
    vids.forEach(function (v) { io.observe(v); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-hero-toggle]');
    if (!b) return;
    e.preventDefault();
    paused = !paused;
    sync();
  });
  addEventListener('resize', sync);
  document.addEventListener('visibilitychange', sync);
  sync();
  var kick = function () { (window.requestIdleCallback || function (f) { return setTimeout(f, 1); })(function () { armed = true; sync(); }, { timeout: 2000 }); };
  if (document.readyState === 'complete') kick(); else addEventListener('load', kick, { once: true });
})();

/* 2026-09-12 perf (audit P0-3): pictures nobody sees until they act. build_perf.py leaves card hover pictures (desktop)
   without src and gives the second picture of a mobile card carousel a 64 px preview; this swaps in the real ones. */
function cladLoadDeferred(scope) {
  var ims = scope.querySelectorAll('img[data-srcset], img[data-src]');
  for (var k = 0; k < ims.length; k++) {
    var im = ims[k];
    if (im.hasAttribute('data-srcset')) { im.setAttribute('srcset', im.getAttribute('data-srcset')); im.removeAttribute('data-srcset'); }
    if (im.hasAttribute('data-src')) { im.setAttribute('src', im.getAttribute('data-src')); im.removeAttribute('data-src'); }
  }
}
/* 2026-09-12: mobile collection cards swipe to the second picture; keep the two dots in step */
document.addEventListener('scroll', function (e) {
  var t = e.target;
  if (!t || !t.hasAttribute || !t.hasAttribute('data-mc-track')) return;
  cladLoadDeferred(t);
  var i = Math.round(t.scrollLeft / Math.max(1, t.clientWidth)), dots = t.parentNode.querySelectorAll('.mc-dots i');
  for (var k = 0; k < dots.length; k++) dots[k].className = k === i ? 'on' : '';
}, true);
document.addEventListener('touchstart', function (e) {
  var t = e.target.closest && e.target.closest('[data-mc-track]');
  if (t) cladLoadDeferred(t);
}, { passive: true, capture: true });
/* 2026-09-15: a phone card's second picture is ready before it is swiped (cards near the screen load it, with lazy loading
   off so the sideways-hidden picture still downloads), and a mouse over a phone card slides to it and back */
(function () {
  var tracks = document.querySelectorAll('[data-mc-track]');
  if (!tracks.length) return;
  function ready(t) { cladLoadDeferred(t); var ims = t.querySelectorAll('img[loading="lazy"]'); for (var k = 0; k < ims.length; k++) ims[k].removeAttribute('loading'); }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { ready(e.target); io.unobserve(e.target); } }); }, { rootMargin: '400px 0px' });
    for (var k = 0; k < tracks.length; k++) io.observe(tracks[k]);
  } else {
    for (var j = 0; j < tracks.length; j++) ready(tracks[j]);
  }
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse') return;
    var t = e.target.closest && e.target.closest('[data-mc-track]');
    if (!t || t.children.length < 2 || t.scrollLeft > 0) return;
    ready(t); t.scrollTo({ left: t.clientWidth, behavior: 'smooth' });
  }, { passive: true });
  document.addEventListener('pointerout', function (e) {
    if (e.pointerType !== 'mouse') return;
    var t = e.target.closest && e.target.closest('[data-mc-track]');
    if (!t || (e.relatedTarget && t.contains(e.relatedTarget))) return;
    t.scrollTo({ left: 0, behavior: 'smooth' });
  }, { passive: true });
})();
/* card hover pictures: the card under the mouse loads at once, the rest of its grid right after */
document.addEventListener('pointerover', function (e) {
  if (e.pointerType && e.pointerType !== 'mouse') return;
  var a = e.target.closest && e.target.closest('a');
  if (!a || !a.querySelector('img[data-src]')) return;
  cladLoadDeferred(a);
  var grid = a.parentNode;
  setTimeout(function () { if (grid) cladLoadDeferred(grid); }, 250);
}, { passive: true });
